export default [
  {
    id: 'operation_type',
    title: 'Operation Type',
    multiSelect: true,
    options: [{ id: 'urn:lic:id:party:unregulated', name: 'Tag Only' }],
  },
]
